<div class="card card-box rounded border-0 p-3">
    <div class="py-0">
        <h3 class="text-center">Comptes comptables</h3>
    </div>
    <hr class="border-2">
    <div class="d-flex justify-content-end my-1">
        <div class="d-flex align-items-center">
            <button (click)="add()" class="btn btn-primary button-radius" tooltip="Ajouter un compte tva" type="button">
                <i class="fas fa-plus-circle"></i> Ajouter
            </button>
        </div>
        <div class="btn-group float-right m-1 btn-outil-owner" ngbDropdown>
          <button class="btn btn-warning" ngbDropdownToggle type="button">
            Outils <i class="fas fa-tools"></i>
          </button>
          <div class="dropdown-menu-right" ngbDropdownMenu>
            <a class="dropdown-item" (click)="onImport()"
              ngbTooltip="Cliquez ici pour importer un fichier">
              Importer <i class="feather icon-download"></i>
            </a>
          </div>
        </div>
    </div>
    <span class="badge badge-primary my-2 f-14 width">Liste des comptes comptables </span>
    <app-no-data *ngIf="plans && plans.length === 0" [title]="'Aucun compte comptable trouvé'"></app-no-data>
    <div *ngIf="plans && plans.length > 0">
        <div class="table-responsive m-0">
            <table datatable [dtOptions]="dtOptions" class="table table-striped m-0">
                <thead class="thead-light">
                    <tr>
                        <th>Code</th>
                        <th>Numéro</th>
                        <th>Libellé</th>
                        <th>Libellé court</th>
                        <th>Compte du père</th>
                        <th>Activé</th>
                        <th>Créer le</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of plans; let i = index">
                        <td>
                            {{item?.code}}
                        </td>
                        <td>
                            {{item?.numero}}
                        </td>
                        <td>
                            {{item?.libelle}}
                        </td>
                        <td>
                            {{item?.libelleCourt}}
                        </td>
                        <td>
                            {{item?.numeroParent ? item?.numeroParent : 'Non défini'}}
                        </td>
                        <td>
                            <div class="switch d-inline m-r-10">
                                <input (change)="onChange(item)" type="checkbox" id="switch-{{i}}" [checked]="item.etat === 'ACTIF' ? true : false">
                                <label for="switch-{{i}}" class="cr"></label>
                            </div>                    
                        </td>
                        <td>{{item?.createdAt|date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR'}}</td>
                        <td class="text-center">
                            <button type="button" (click)="edit(item)" class="btn btn-icon btn-primary ml-1" ngbTooltip="Modifier">
                                <i class="feather icon-edit-2"></i>
                            </button>
                            <button type="button" (click)="delete(item)" class="btn btn-icon btn-danger ml-1" ngbTooltip="Supprimer">
                                <i class="feather icon-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>